/**
 * Survey API Service
 * Handles all survey-related API calls
 */

import surveyApiInstructorMixin from './surveyApi/surveyApiInstructor';
import surveyApiStudentMixin from './surveyApi/surveyApiStudent';
import surveyApiPublicMixin from './surveyApi/surveyApiPublic';

class SurveyApiService {}

Object.assign(SurveyApiService.prototype, surveyApiInstructorMixin);
Object.assign(SurveyApiService.prototype, surveyApiStudentMixin);
Object.assign(SurveyApiService.prototype, surveyApiPublicMixin);

const surveyApiService = new SurveyApiService();
export default surveyApiService;
